// import React, { useMemo } from 'react';
// import { Avatar, Tag, Typography } from 'antd';
// import { useQuery } from '@tanstack/react-query';
// import dayjs from 'dayjs';
// import CrudPage from '../../components/common/CrudPage';
// import adminService from '../../services/adminManagementRequest';
// import roleService from '../../services/roleManagementRequest';

// const { Text } = Typography;

// const ACCOUNT_STATUS = {
//   ACTIVE: 1,
//   INACTIVE: 0,
// };

// const AccountManagement = () => {
//   // Lấy danh sách role để hiển thị tên role và cho select trong form
//   const { data: roleData } = useQuery({
//     queryKey: ['roles-for-select'],
//     queryFn: () => roleService.getList({ limit: 100 }),
//   });

//   const roleOptions = useMemo(() => {
//     const list = roleData?.data || roleData || [];
//     if (!Array.isArray(list)) return [];
//     return list.map((r) => ({ label: r.name, value: r.id }));
//   }, [roleData]);

//   // Hàm tìm tên role theo id
//   const getRoleName = (roleId) => {
//     if (roleId === 9999) return 'FULL';
//     const found = roleOptions.find((r) => r.value === roleId);
//     return found?.label || '-';
//   };

//   const columns = [
//     {
//       title: 'TÊN ĐĂNG NHẬP',
//       dataIndex: 'username',
//       key: 'username',
//       render: (text) => <Text strong>{text}</Text>,
//     },
//     {
//       title: 'HỌ VÀ TÊN',
//       key: 'fullname',
//       render: (_, record) => `${record.first_name || ''} ${record.last_name || ''}`.trim() || '-',
//     },
//     {
//       title: 'ẢNH',
//       dataIndex: 'avatar',
//       key: 'avatar',
//       width: 80,
//       align: 'center',
//       render: (value) => value && <Avatar src={value} size={40} shape="square" />,
//     },
//     {
//       title: 'VỊ TRÍ',
//       dataIndex: 'job',
//       key: 'job',
//       render: (value) => value || '-',
//     },
//     {
//       title: 'NGÀY SINH',
//       dataIndex: 'birthday',
//       key: 'birthday',
//       render: (value) => (value ? dayjs(value).format('DD/MM/YYYY') : '-'),
//     },
//     {
//       title: 'EMAIL',
//       dataIndex: 'email',
//       key: 'email',
//       render: (value) => value || '-',
//     },
//     {
//       title: 'SĐT',
//       dataIndex: 'phone',
//       key: 'phone',
//       render: (value) => value || '-',
//     },
//     {
//       title: 'QUYỀN',
//       dataIndex: 'role',
//       key: 'role',
//       render: (value) => <Tag color="blue">{getRoleName(value)}</Tag>,
//     },
//     {
//       title: 'TRẠNG THÁI',
//       dataIndex: 'is_active',
//       key: 'is_active',
//       render: (value) => (
//         <Tag color={value === ACCOUNT_STATUS.ACTIVE ? 'green' : 'red'}>
//           {value === ACCOUNT_STATUS.ACTIVE ? 'Hoạt động' : 'Khóa'}
//         </Tag>
//       ),
//     },
//   ];

//   const formFields = useMemo(
//     () => [
//       {
//         name: 'avatar',
//         label: 'Ảnh đại diện',
//         type: 'upload-cdn',
//         lg: 24,
//       },
//       {
//         name: 'first_name',
//         label: 'First name',
//         rules: [{ required: true }],
//         lg: 12,
//       },
//       {
//         name: 'last_name',
//         label: 'Last name',
//         rules: [{ required: true }],
//         lg: 12,
//       },
//       {
//         name: 'username',
//         label: 'Tên đăng nhập',
//         rules: [{ required: true }],
//         lg: 12,
//       },
//       {
//         name: 'email',
//         label: 'Email',
//         rules: [{ type: 'email', message: 'Email không hợp lệ' }],
//         lg: 12,
//       },
//       {
//         name: 'phone',
//         label: 'Số điện thoại',
//         lg: 12,
//       },
//       {
//         name: 'job',
//         label: 'Vị trí',
//         lg: 12,
//       },
//       {
//         name: 'birthday',
//         label: 'Ngày sinh',
//         type: 'date',
//         submitFormat: 'YYYY-MM-DD',
//         lg: 12,
//       },
//       {
//         name: 'role',
//         label: 'Quyền',
//         type: 'select',
//         options: roleOptions,
//         rules: [{ required: true }],
//         lg: 12,
//       },
//       {
//         name: 'is_active',
//         label: 'Trạng thái hoạt động',
//         type: 'switch',
//         defaultChecked: true,
//         lg: 12,
//       },
//       {
//         name: 'password',
//         label: 'Mật khẩu',
//         type: 'password',
//         lg: 12,
//         propsInput: { autoComplete: 'new-password' },
//       },
//     ],
//     [roleOptions]
//   );

//   return (
//     <CrudPage
//       title="QUẢN LÝ TÀI KHOẢN"
//       subTitle="Quản lý tài khoản admin hệ thống"
//       itemsName="Tài khoản"
//       queryKey="admin-accounts"
//       service={adminService}
//       columns={columns}
//       formFields={formFields}
//       searchPlaceholder="Tìm kiếm tài khoản..."
//       addButtonLabel="Thêm tài khoản"
//       disableCopy={true}
//       formConfig={{ width: 700 }}
//     />
//   );
// };

// export default AccountManagement;

import { App, Avatar, Button, Col, Form, Row, Switch, Table, Typography } from 'antd';
import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { useQuery } from '@tanstack/react-query';
import adminService from '../../services/adminManagementRequest';
// import EditAccount from '../../components/editAccount';
import dayjs from 'dayjs';
// import { DEFAULT_AVATAR } from '../../constants/AppSelect';
import roleService from '../../services/roleManagementRequest';
import TableAction from '../../components/common/TableAction';
import EditAccount from '../../components/common/editAccount';
// import ActionsTables from '../../components/ActionsTables';


const ACCOUNT_STATUS = {
  ACTIVE: 1,
  INACTIVE: 0,
};

const StatusSwitch = ({ record, refetch }) => {
  const { message } = App.useApp();
  const [loading, setLoading] = useState(false);

  const onChange = async (checked) => {
    setLoading(true);
    try {
      // Spread record để giữ các giá trị cũ và chỉ thay đổi is_active (vì BE require full object)
      const { key, created_at,link_zoom, updated_at, ...updateData } = record;
      await adminService.update(record.id, {
        ...updateData,
        change_password: false,
        is_active: checked ? ACCOUNT_STATUS.ACTIVE : ACCOUNT_STATUS.INACTIVE,
      });
      message.success('Cập nhật trạng thái thành công');
      refetch();
    } catch (error) {
      message.error('Cập nhật trạng thái thất bại');
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return <Switch checked={!!record.is_active} onChange={onChange} loading={loading} />;
};

StatusSwitch.propTypes = {
  record: PropTypes.object.isRequired,
  refetch: PropTypes.func.isRequired,
};

const AccountManagement = () => {
  const { message } = App.useApp();
  const [modalOpen, setModalOpen] = useState(false);
  const [formEdit] = Form.useForm();
  const [formAdding, setFormAdding] = useState(false);
  const { data, isLoading, refetch } = useQuery({ queryKey: ['list-admin'], queryFn: () => adminService.getList() });
  const { data: roleManagement } = useQuery({ queryKey: ['list-roles'], queryFn: () => roleService.getList() });
  const columns = [
    {
      title: 'STT',
      width: 60,
      render: (text, object, index) => index + 1,
    },
    {
      title: 'Tên đăng nhập',
      dataIndex: 'username',
    },
    {
      title: 'Họ và tên',
      render: (_, object) => `${object.first_name} ${object.last_name}`,
    },
    {
      title: 'Ảnh đại diện',
      dataIndex: 'avatar',
      render: (value) => value && <Avatar src={value} size={50} shape={'square'} />,
    },
    {
      title: 'Vị trí',
      dataIndex: 'job',
    },
    {
      title: 'Ngày sinh',
      dataIndex: 'birthday',
      render: (value) => (value ? dayjs(value).format('DD/MM/YYYY') : ''),
    },
    {
      title: 'Email',
      dataIndex: 'email',
    },
    {
      title: 'Số điện thoại',
      dataIndex: 'phone',
    },
    {
      title: 'Quyền',
      dataIndex: 'role',
      render: (value) => {
        if (value === 9999) return 'FULL';
        const roles = Array.isArray(roleManagement)
          ? roleManagement
          : roleManagement?.roles || roleManagement?.data || [];
        return roles.find((item) => item.id === value)?.name || '-';
      },
    },
    {
      title: 'Trạng thái',
      dataIndex: 'is_active',
      render: (_, record) => <StatusSwitch record={record} refetch={refetch} />,
    },
    {
      title: '',
      dataIndex: 'action',
      width: 120,
      align: 'center',
      render: (_, item) => (
        <TableAction
          record={item}
          onEdit={(record) => {
            formEdit.setFieldsValue({
              ...record,
              birthday: record.birthday ? dayjs(record.birthday) : undefined,
              change_password: false,
              avatar: record.avatar ? [{ uid: 1, name: 'avatar', status: 'done', url: record.avatar }] : [],
            });
            setFormAdding(false);
            setModalOpen(true);
          }}
          onCopy={(record) => {
            const { id, created_at, updated_at, ...rest } = record;
            formEdit.setFieldsValue({
              ...rest,
              birthday: record.birthday ? dayjs(record.birthday) : undefined,
              password: undefined,
              avatar: record.avatar ? [{ uid: 1, name: 'avatar', status: 'done', url: record.avatar }] : [],
            });
            setFormAdding(true);
            setModalOpen(true);
          }}
          onDelete={async (record) => {
            try {
              await adminService.delete(record.id);
              message.success('Xóa tài khoản thành công');
              refetch();
            } catch (error) {
              message.error('Xóa tài khoản thất bại');
              console.error(error);
            }
          }}
        />
      ),
    },
  ];
  return (
    <>
      <Typography.Title level={4} className={'uppercase text-center'}>
        Quản lý tài khoản admin
      </Typography.Title>
      <Row justify="end" gutter={[20, 20]}>
        <Col>
          <Button
            onClick={() => {
              formEdit.resetFields();
              setFormAdding(true);
              setModalOpen(true);
            }}
            className={'bg-white border-violet-500 text-violet-500'}
          >
            Thêm tài khoản
          </Button>
        </Col>
      </Row>
      <div>
        <Table
          className={'mt-10'}
          bordered
          loading={isLoading}
          pagination={false}
          scroll={{ x: 1000 }}
          columns={columns}
          dataSource={data?.map((item, key) => ({ ...item, key }))}
        />
        <EditAccount
          modalOpen={modalOpen}
          setModalOpen={setModalOpen}
          disabled={false}
          formEdit={formEdit}
          func={formAdding ? adminService.create : (data) => adminService.update(data.id, data)}
          formAdding={formAdding}
          handleSuccess={() => refetch()}
          roleManagement={roleManagement}
        />
      </div>
    </>
  );
};

export default AccountManagement;
